/*
 * @Author: libo 
 * @Date: 2020-11-13 17:35:28 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-11-15 14:25:34
 */


<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
    </template>
    <meter-returnPremium-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-returnPremium-form>
  </j-modal>
</template>

<script>

  import MeterReturnPremiumForm from './MeterReturnPremiumForm'
  export default {
    name: 'MeterreturnPremiumModal',
    components: {
      MeterReturnPremiumForm
    },
    data () {
      return {
        title:'',
        width:1100,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.$refs.realForm.shut();
        this.close()
      }
    }
  }
</script>
